import { api } from './client';

export interface BackendCrop {
  _id: string;
  name: string;
  scientificName?: string;
  groupLabel?: string;
  typicalCycleDays?: number;
  avgYieldPerHaKg?: number;
  scope: 'GLOBAL' | 'HTX';
  htxId?: string;
  active: boolean;
}

export type CultivationProcessStatus = 'DRAFT' | 'ACTIVE' | 'RETIRED';

export interface BackendCultivationProcess {
  _id: string;
  cropId: string;
  code: string;
  name: string;
  version: number;
  status: CultivationProcessStatus;
  description?: string;
}

export async function listCrops(htxId?: string): Promise<BackendCrop[]> {
  const query = htxId ? `?htxId=${htxId}` : '';
  return api.get<BackendCrop[]>(`/crops${query}`);
}

export async function listCultivationProcessesByCrop(cropId: string, includeRetired = false): Promise<BackendCultivationProcess[]> {
  return api.get<BackendCultivationProcess[]>(`/cultivation-processes/by-crop/${cropId}?includeRetired=${includeRetired}`);
}

export interface BackendScheduleEventCreated {
  _id: string;
  seasonId: string;
  eventType: string;
  plannedDate: string;
  status: string;
  note?: string;
}

export async function applyCultivationProcess(seasonId: string, processId: string): Promise<BackendScheduleEventCreated[]> {
  return api.post<BackendScheduleEventCreated[]>(`/schedule-events/seasons/${seasonId}/apply-cultivation-process/${processId}`);
}
